import { React, useState, useEffect } from "react";
import { MovieCard } from "../MovieCard/MovieCard";
import { Row } from "react-bootstrap";

export const UserFavoriteMovies = ({
	user,
	favoriteMovies,
	setFavoriteMovies,
	movies,
	token,
}) => {
	// console.log(favoriteMovies);
	// console.log(movies);

	useEffect(() => {
		console.log("mounted");
	}, [favoriteMovies]);

	return (
		<Row>
			{favoriteMovies.map((movie) => {
				return (
					<MovieCard
						key={movie.id}
						user={user}
						movieData={movie}
						setFavoriteMovies={setFavoriteMovies}
						favoriteMovies={favoriteMovies}
						token={token}
					/>
				);
			})}
		</Row>
	);
};
